import {createAsyncAction, errorResult, registerInDevtools, Store, successResult} from "pullstate";
import {PulseViewModel} from "../viewModel/PulseView.model";
import {PulseServices} from "../services/PulseServices";


export interface PulseStoreInterface {
    pulses: PulseViewModel[]
}

const PulseStoreInitialState = {
    pulses: []
};

export const PulseStore = new Store<PulseStoreInterface>(PulseStoreInitialState);

registerInDevtools({
    PulseStore
});


export namespace PulseStoreActions{

    export interface FindAllPulsesOutput {
        pulses?: PulseViewModel[]
    }

    export interface FindAllPulsesInput {
        eventId: number
    }
    export const findAllPulsesByEventId = createAsyncAction<FindAllPulsesInput, FindAllPulsesOutput>(
        async ({eventId}) => {
            try {
                const result = await PulseServices.findPulseListForEvent(eventId);

                return successResult({ pulses: result });
            } catch (error) {
                return errorResult([], `Couldn't get pulses: ${error}`);
            }
        },
        {
            postActionHook: ({result}) => {
                if (result.payload && result.payload.pulses && !result.error) {
                    PulseStore.update(s => {
                        s.pulses = result.payload.pulses as PulseViewModel[];
                    });
                }
            }
        }
    );


    export const flushStore = () => {
        PulseStore.update((x) => {
            x.pulses = PulseStoreInitialState.pulses;
        });
    }


}

//
// export interface AddPulseInput {
//     pulse: PulseAddBean.Model
// }
//
//
// export const addPulseAction = createAsyncAction<AddPulseInput, boolean>(
//     async ({pulse}) => {
//         try {
//             const result = await PulseServices.addPulse(pulse)
//
//             EventStore.update(e=> {
//                 let number = e.events.findIndex(ev => ev.eventId == pulse.eventId);
//                 e.events[number].totalPulses = e.events[number].totalPulses + 1;
//             })
//
//             return successResult(result);
//         } catch (error) {
//             return errorResult([], error as string);
//         }
//     }
// )


